import type React from 'react';
import { LOCKED_FEATURE_CONTENT, type LockedFeature } from '../lib/release-flags';

interface FeatureComingSoonPageProps {
  feature: LockedFeature;
}

export function FeatureComingSoonPage({ feature }: FeatureComingSoonPageProps): React.ReactElement {
  const content = LOCKED_FEATURE_CONTENT[feature];

  return (
    <div className="relative min-h-full overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(196,247,14,0.12),transparent_45%),radial-gradient(circle_at_bottom_right,rgba(251,146,60,0.10),transparent_35%)]" />

      <div className="relative mx-auto flex min-h-[calc(100vh-4rem)] max-w-4xl items-center justify-center px-6 py-12">
        <div className="clip-notched border border-white/10 bg-black/40 p-8 backdrop-blur-xl md:p-10">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#c4f70e]/30 bg-[#c4f70e]/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-[#c4f70e]">
            <span className="h-2 w-2 rounded-full bg-[#c4f70e]" />
            {content.badge}
          </div>

          <h1 className="max-w-2xl text-4xl font-bold tracking-tight text-white md:text-5xl">
            {content.title}
          </h1>
          <p className="mt-4 max-w-2xl text-base text-gray-400 md:text-lg">{content.description}</p>

          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {content.highlights.map((area) => (
              <div
                key={area}
                className="flex items-center justify-between rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3"
              >
                <span className="text-sm font-medium text-white">{area}</span>
                <span className="rounded-full border border-orange-400/30 bg-orange-500/10 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-orange-300">
                  Coming Soon
                </span>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="https://wensite.fun"
              className="inline-flex items-center justify-center rounded-xl bg-[#c4f70e] px-5 py-3 text-sm font-semibold text-black transition-colors hover:bg-[#d7ff46]"
            >
              Back to landing
            </a>
            <div className="inline-flex items-center justify-center rounded-xl border border-white/10 px-5 py-3 text-sm text-gray-400">
              This area is being held for release hardening
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
